// extracted by mini-css-extract-plugin
export default {"container":"NoPermission_container__m53PF","paragraph":"NoPermission_paragraph__EfTaa"};